"use client";

import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const items = [
  { id: "c1", title: "Card One", description: "Selectable card" },
  { id: "c2", title: "Card Two", description: "Selectable card" },
  { id: "c3", title: "Card Three", description: "Selectable card" },
  { id: "c4", title: "Card Four", description: "Selectable card" },
];

export default function ModalComponentPickerExample() {
  const [open, setOpen] = React.useState(true);
  const [selected, setSelected] = React.useState<string | null>(null);
  return (
    <div className="space-y-4">
      <Button onClick={() => setOpen(true)}>Open Card Picker Modal</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-6xl! w-6xl! bg-transparent shadow-none border-0 p-0">
          <div className="bg-card/95 backdrop-blur-xl rounded-xl w-full overflow-hidden shadow-2xl border border-white/10 flex flex-col" style={{ minHeight: "60vh" }}>
            <div className="p-6 pb-4 border-b border-white/10 bg-gradient-to-b from-primary/5 to-transparent">
              <h2 className="text-2xl font-bold text-foreground">Component Picker</h2>
              <p className="mt-2 text-muted-foreground">Select a card.</p>
            </div>
            <div className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {items.map(i => (
                <Card key={i.id} className={`cursor-pointer transition-shadow ${selected===i.id?"ring-2 ring-primary":""}`} onClick={() => setSelected(i.id)}>
                  <CardHeader>
                    <CardTitle>{i.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="text-muted-foreground text-sm">{i.description}</div>
                  </CardContent>
                </Card>
              ))}
            </div>
            <div className="mt-auto border-t border-white/10 px-6 py-4 bg-gradient-to-t from-primary/5 to-transparent flex justify-between items-center">
              <div className="text-sm text-muted-foreground">{selected ? `Selected: ${selected}` : "Nothing selected"}</div>
              <div className="flex gap-2">
                <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
                <Button disabled={!selected} onClick={() => setOpen(false)}>Use</Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
